import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import './statusPage.css';
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import AppConstants from "../../../AppConstants";

const StatusPage = () => {
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState({});

  
  const config = useMemo(() => {
    return getConfig()
  },[])
  console.log(config);
  
  const fetchOverallStatus = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/bussiness-status/`, config)
      .then((response) => {
        setStatusList(response.data); 
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 404)
        ) {
          console.log("Session expired. Redirecting to login...");

          localStorage.removeItem(AppConstants.JWT);

          window.location.href = "/login";
        } else {
          console.error("Categories Error:", error);
        }
      });
  };

  useEffect(() => {
    fetchOverallStatus();
  }, []);

  if (loading) {
    return <div className="loader-container">
    <Spinner className="spinner-loader" />
  </div>;
  }

  return (
    <Container className="dashboard-container">
      <Row>
        {Object.entries(statusList).map(([key, value]) => (
          <Col md={3} key={key} className="mb-4">
            <Card className="card">
              <CardContent>
                <Typography variant="h5">{value}</Typography>
                <Typography component="div">{key.replace(/_/g, ' ').toUpperCase()}</Typography>
              </CardContent>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default StatusPage;